import { IonCard, IonCardContent, IonCardHeader, IonCardTitle } from "@ionic/react";
import './AboutMe.css'
function AboutMe(){
    return (
      <div>
        <IonCard className="ion-hide-sm-down ion-padding">
          <IonCardHeader>
            <IonCardTitle className="ion-text-center">Who am I?</IonCardTitle>
          </IonCardHeader>
          <IonCardContent className="ion-text-justify">
            Hello! I'm a data scientist at{" "}
            <a
              href="https://about.facebook.com/meta"
              target="_blank"
              rel="noreferrer"
            >
              Meta
            </a>{" "}
            and University of Chicago alumna. Previously, I interned at Instagram and worked at a couple early-stage startups. In my free time,
            I like to build full-stack apps and write. 
            <br />
            <br/>
            Outside of the technical sphere, I love
            dogs, traveling, and libraries!
          </IonCardContent>
        </IonCard>

        <IonCard className="ion-hide-sm-up">
          <IonCardHeader>
            <IonCardTitle className="ion-text-center">Who am I? </IonCardTitle>
          </IonCardHeader>
          <IonCardContent className="ion-text-justify"></IonCardContent>
        </IonCard>
      </div>
    );
}


export default AboutMe;